export type ScaleType = 'STRETCH' | 'CENTER' | { xOffset: number, yOffset: number, scale?: number };

export type PosterSize =
    '30x30' | '50x50' | '80x80' |
    '13x18' | '21x30' | '30x40' | '50x70' | '50x75' | '60x80' | '70x100' | '80x120' | '100x140' |
    '18x13' | '30x21' | '40x30' | '70x50' | '75x50' | '80x60' | '100x70' | '120x80' | '140x100';

export const squarePosterSizes = ['30x30', '50x50'];
export const squareCanvasSizes = ['50x50', '80x80'];

export const verticalPosterSizes = ['13x18', '21x30', '30x40', '40x50', '50x70', '70x100', '100x140'];
export const verticalCanvasSizes = ['20x30', '30x40', '40x50', '40x60', '50x70', '50x75', '60x80', '70x100', '80x120'];

export const horizontalPosterSizes = ['18x13', '30x21', '40x30', '50x40', '70x50', '100x70', '140x100'];
export const horizontalCanvasSizes = ['30x20', '40x30', '50x40', '60x40', '70x50', '75x50', '80x60', '100x70', '120x80'];


export const allPosterSizes = squarePosterSizes.concat(verticalPosterSizes, horizontalPosterSizes);
export const allCanvasSizes = squareCanvasSizes.concat(verticalCanvasSizes, horizontalCanvasSizes);

export interface IPosterSizeDimensionsBySize { [size: string]: IPosterSizeDimensions };
export interface IPosterSizeDimensions {
    width: number;
    height: number;
    mmWidth: number;
    mmHeight: number;
}

export const posterSizesByName: IPosterSizeDimensionsBySize = {
    // Vertical 
    '13x18': {
        width: 13,
        height: 18,
        mmWidth: 136,
        mmHeight: 186
    },
    '21x30': {
        width: 21,
        height: 30,
        mmWidth: 216,
        mmHeight: 306
    },
    '30x40': {
        width: 30,
        height: 40,
        mmWidth: 306,
        mmHeight: 406
    },

    '40x50': {
        width: 40,
        height: 50,
        mmWidth: 406,
        mmHeight: 506
    },

    '50x70': {
        width: 50,
        height: 70,
        mmWidth: 506,
        mmHeight: 706
    },
    '70x100': {
        width: 70,
        height: 100,
        mmWidth: 706,
        mmHeight: 1006
    },
    '100x140': {
        width: 100,
        height: 140,
        mmWidth: 1006,
        mmHeight: 1406
    },

    //Square
    '30x30': {
        width: 30,
        height: 30,
        mmWidth: 306,
        mmHeight: 306
    },
    '50x50': {
        width: 50,
        height: 50,
        mmWidth: 506,
        mmHeight: 506
    },


    // Horizontal
    '18x13': {
        width: 18,
        height: 13,
        mmWidth: 186,
        mmHeight: 136
    },
    '30x21': {
        width: 30,
        height: 21,
        mmWidth: 306,
        mmHeight: 216
    },
    '40x30': {
        width: 40,
        height: 30,
        mmWidth: 406,
        mmHeight: 306
    },

    '50x40': {
        width: 50,
        height: 40,
        mmWidth: 506,
        mmHeight: 406
    },
    '70x50': {
        width: 70,
        height: 50,
        mmWidth: 706,
        mmHeight: 506
    },
    '100x70': {
        width: 100,
        height: 70,
        mmWidth: 1006,
        mmHeight: 706
    },
    '140x100': {
        width: 140,
        height: 100,
        mmWidth: 1406,
        mmHeight: 1006
    }


}


export const canvasSizesByName: IPosterSizeDimensionsBySize = {
    // Vertical
    '20x30': {
        width: 20,
        height: 30,
        mmWidth: 262,
        mmHeight: 362
    },
    '30x40': {
        width: 30,
        height: 40,
        mmWidth: 362,
        mmHeight: 462
    },
    '40x50': {
        width: 40,
        height: 50,
        mmWidth: 462,
        mmHeight: 562
    },
    '40x60': {
        width: 40,
        height: 60,
        mmWidth: 462,
        mmHeight: 662
    },
    '50x70': {
        width: 50,
        height: 70,
        mmWidth: 562,
        mmHeight: 762
    },
    '50x75': {
        width: 50,
        height: 75,
        mmWidth: 562,
        mmHeight: 812
    },
    '80x60': {
        width: 80,
        height: 60,
        mmWidth: 862,
        mmHeight: 662
    },
    '70x100': {
        width: 70,
        height: 100,
        mmWidth: 762,
        mmHeight: 1062
    },
    '80x120': {
        width: 80,
        height: 120,
        mmWidth: 862,
        mmHeight: 1262
    },

    // Square
    '50x50': {
        width: 50,
        height: 50,
        mmWidth: 562,
        mmHeight: 562
    },
    '80x80': {
        width: 80,
        height: 80,
        mmWidth: 862,
        mmHeight: 862
    },

    // Horizontal
    '30x20': {
        width: 30,
        height: 20,
        mmWidth: 362,
        mmHeight: 262
    },
    '40x30': {
        width: 40,
        height: 30,
        mmWidth: 462,
        mmHeight: 362
    },
    '50x40': {
        width: 50,
        height: 40,
        mmWidth: 562,
        mmHeight: 462
    },
    '60x40': {
        width: 60,
        height: 40,
        mmWidth: 662,
        mmHeight: 462
    },
    '70x50': {
        width: 70,
        height: 50,
        mmWidth: 762,
        mmHeight: 562
    },
    '75x50': {
        width: 75,
        height: 50,
        mmWidth: 812,
        mmHeight: 562
    },
    '60x80': {
        width: 60,
        height: 80,
        mmWidth: 662,
        mmHeight: 862
    },
    '100x70': {
        width: 100,
        height: 70,
        mmWidth: 1062,
        mmHeight: 762
    },
    '120x80': {
        width: 120,
        height: 80,
        mmWidth: 1262,
        mmHeight: 862
    },

}


export const otherSizesByName: IPosterSizeDimensionsBySize = {
    'STD_MUG_11': {
        width: 19.8,
        height: 9.7,
        mmWidth: 198,
        mmHeight: 97
    },
    'STD_STUDENT_50x70': {
        width: 50,
        height: 70,
        mmWidth: 506,
        mmHeight: 706
    },
}

export const posterSizes = [
    posterSizesByName['13x18'],
    posterSizesByName['21x30'],
    posterSizesByName['30x40'],
    posterSizesByName['40x50'],
    posterSizesByName['50x50'],
    posterSizesByName['50x70'],
    posterSizesByName['70x100'],
    posterSizesByName['100x140']
];